import { combineReducers, configureStore } from '@reduxjs/toolkit'
import root from './reducers'
import parcelsReducer from './parcels/slice.parcels'
import usersReducer from './users/slice.users'
import carriersReducer from './carriers/slice.carriers'
import locationsReducer from './locations/slice.locations'
import { SESSION_ENDED } from './session'

const reducers = combineReducers({
  root,
  parcels: parcelsReducer,
  users: usersReducer,
  carriers: carriersReducer,
  locations: locationsReducer,
})

// A new session starts every slice from its initial state
export default configureStore({
  reducer: (state, action) =>
    reducers(action.type === SESSION_ENDED ? undefined : state, action),
})
